import React, { useState, useEffect } from "react"
import { format } from "date-fns"
import { enUS } from "date-fns/locale"
import { Calendar } from "react-date-range"
import { Spinner } from "reactstrap"
import calendarIcon from "../../assets/images/icons/calendar.svg"
import { convertDateTime, dateTimeFormat } from "utils/dateFormatUtils"

export const DatePicker = ({
   selected,
   onChange,
   placeholderText = "Select Date",
   minDate,
   className = "",
   dateFormat = dateTimeFormat.americanFormat,
   isLoading = false,
   disabled = false,
}) => {
   const [isOpen, setIsOpen] = useState(false)
   const [tempDate, setTempDate] = useState(selected || new Date())

   useEffect(() => {
      if (selected) {
         setTempDate(new Date(selected))
      }
   }, [isOpen])

   const formatted = selected
      ? convertDateTime({
           date: selected,
           dateOnly: true,
           customFormat: dateFormat,
           utc: true,
        })
      : ""

   return (
      <div className="date-range-wrapper position-relative">
         <div className="input-container d-flex align-items-center">
            <input
               type="text"
               readOnly
               placeholder={placeholderText}
               value={formatted}
               className={`input-field ${className}`}
               onClick={() => setIsOpen(open => !open)}
               disabled={isLoading || disabled}
            />
            {isLoading ? (
               <Spinner size="sm" color="primary" className="input-loader" />
            ) : (
               <img
                  src={calendarIcon}
                  alt="Calendar Icon"
                  className={`input-icon position-absolute end-0 me-2 ${
                     disabled ? "input-icon-disabled" : "input-icon-enabled"
                  }`}
               />
            )}
         </div>

         {isOpen && (
            <div className="calendar-container bg-white p-2 rounded shadow position-absolute z-100">
               <Calendar
                  date={tempDate}
                  onChange={date => setTempDate(date)}
                  minDate={minDate}
                  locale={enUS}
                  dateFormat={dateFormat}
               />
               <div className="d-flex justify-content-end mt-2 gap-2">
                  <button
                     type="button"
                     className="btn btn-secondary btn-sm"
                     onClick={() => {
                        setTempDate(selected || new Date())
                        setIsOpen(false)
                     }}
                  >
                     Cancel
                  </button>
                  <button
                     type="button"
                     className="btn btn-primary btn-sm"
                     onClick={() => {
                        onChange(tempDate)
                        setIsOpen(false)
                     }}
                  >
                     Done
                  </button>
               </div>
            </div>
         )}
      </div>
   )
}

export default DatePicker
